
<template>
  <div
    v-tooltip.right-center="text"
    class="me-1"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'AdditionalExplanation',
  props: {
    text: {
      required: true,
      type: String,
    },
  },
}
</script>
